import { Controller } from '@hotwired/stimulus';
import alertify from 'shared/alertify';

export default class extends Controller {
  static outlets = ['modal'];

  // action="click->preview-modal#open"
  async open(event) {
    event.preventDefault();

    let html;
    try {
      const response = await fetch(this.element.href, {
        headers: { Accept: 'text/html' },
      });
      if (!response.ok) throw new Error(response.statusText);
      html = await response.text();
    } catch (error) {
      console.error(error);
      alertify.error('エラー');
      this.modalOutlet.close();
      return;
    }

    const height =
      (window.innerHeight || document.documentElement.clientHeight) * 0.75;
    const modal = this.modalOutlet.element;
    modal.innerHTML = html;
    this.modalOutlet.open();
    for (const inner of modal.querySelectorAll('.outer .inner')) {
      inner.style.height = `${height}px`;
    }
  }
}
